import getZoomLevelsConfig from './getZoomLevelsConfig';
import dateHelper from '$$dateFormatsHelper';

class Zoom {
  constructor() {
    this.instance = null;
  }

  init(instance) {
    this.instance = instance;
    this.instance.ext.zoom.init(getZoomLevelsConfig(this.instance));
    this.setZoomLevel(this.instance.config.durationData.mode);
  }

  setZoomLevel(levelName) {
    this.instance.config.durationData.mode = levelName;
    this.#setGanttConfigByLevel(levelName);
    this.instance.ext.zoom.setLevel(levelName);
  }

  #setGanttConfigByLevel(level) {
    const projectConfig = this.instance.ganttDataApi.getActiveProjectConfig();

    if (level === 'hour') {
      this.instance.config.drag_date = dateHelper.getDateFormatForGanttGrid();
      this.instance.config.drag_label_width = 150;
      this.instance.config.min_duration = 30;
      this.instance.config.skip_off_time = true;
      this.instance.config.timeline_highlight = false;
    }

    if (level === 'day') {
      this.instance.config.drag_date = dateHelper.getDateFormatForGanttGrid();
      this.instance.config.drag_label_width = 150;
      this.instance.ignore_time = false;
      this.instance.config.timeline_highlight = true;
      this.instance.config.skip_off_time = projectConfig.skip_off_time || false;
    }

    if (level === 'week') {
      this.instance.config.min_duration = 30;
      this.instance.ignore_time = false;
      this.instance.config.timeline_highlight = false;
      this.instance.config.skip_off_time = projectConfig.skip_off_time || false;
    }

    if (level === 'month') {
      this.instance.config.step = 1;
      this.instance.config.timeline_highlight = false;
      this.instance.config.skip_off_time = projectConfig.skip_off_time || false;
    }

    if (level === 'quarter') {
      this.instance.config.timeline_highlight = false;
      this.instance.config.skip_off_time = projectConfig.skip_off_time || false;
    }

    if (level === 'year') {
      this.instance.config.timeline_highlight = false;
      this.instance.config.skip_off_time = projectConfig.skip_off_time || false;
    }
  }
}

export default new Zoom();
